"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTextInputAlias = void 0;
var getDefaultColors = function (colors, brand) {
    if (brand === 'massey') {
        return {
            color: colors.primary.grays[800],
            borderColor: colors.primary.grays[400],
        };
    }
    if (brand === 'fendt') {
        return {
            color: colors.grays[800],
            borderColor: colors.primary.brand,
        };
    }
    return {
        color: colors.grays[800],
        borderColor: colors.primary.grays[400],
    };
};
var getStateColors = function (colors, brand) {
    var _a = getDefaultColors(colors, brand), color = _a.color, borderColor = _a.borderColor;
    var backgroundColor = colors.primary.white;
    return {
        default: {
            backgroundColor: backgroundColor,
            color: color,
            borderColor: borderColor,
        },
        focus: {
            backgroundColor: brand === 'fendt' ? colors.grays[200] : backgroundColor,
            color: brand === 'fendt' ? colors.primary.brand : color,
            borderColor: borderColor,
        },
        disabled: {
            backgroundColor: backgroundColor,
            color: brand === 'fendt' ? colors.grays[700] : colors.grays[400],
            borderColor: brand === 'fendt' ? colors.grays[700] : colors.grays[600],
        },
        validated: {
            backgroundColor: backgroundColor,
            color: brand === 'fendt' ? colors.error[500] : color,
            borderColor: colors.error[500],
        },
    };
};
var getTextInputAlias = function (globals, brand) {
    var colors = globals.colors, fonts = globals.fonts;
    return __assign({ fontFamily: brand === 'fendt' ? fonts.secondary.bold : fonts.secondary.regular, backgroundColor: colors.primary.white, borderPosition: brand === 'fendt' ? 'bottom' : 'all', borderWidth: brand === 'fendt' ? 2 : 1, paddingLeft: brand === 'fendt' ? 16 : 14, stateColors: getStateColors(colors, brand) }, getDefaultColors(colors, brand));
};
exports.getTextInputAlias = getTextInputAlias;
